import React from "react";
import ReactDOM from "react-dom";
import {ContextContainer} from "./components/context";
import Routing from "./Routing";
import { IntlProvider, addLocaleData } from "react-intl";
import { PageView } from "./ga4";

// import en from "react-intl/locale-data/en";
// import zh from "react-intl/locale-data/zh";
// import vi from "react-intl/locale-data/vi";
// import ko from "react-intl/locale-data/ko";
// import ja from "react-intl/locale-data/ja";
// import sg from "react-intl/locale-data/sg";
// import kr from "react-intl/locale-data/ko";
// import my from "react-intl/locale-data/my";
// import id from "react-intl/locale-data/id";
// import th from "react-intl/locale-data/th";
// import twq from "react-intl/locale-data/twq";
// import az from "react-intl/locale-data/az";
// import arabia from "react-intl/locale-data/ar";
// import ru from "react-intl/locale-data/ru";
// import fil from "react-intl/locale-data/fil";

import '@formatjs/intl-pluralrules/polyfill-force'
import '@formatjs/intl-pluralrules/locale-data/en'
import '@formatjs/intl-pluralrules/locale-data/my'
import '@formatjs/intl-pluralrules/locale-data/sg'
import '@formatjs/intl-pluralrules/locale-data/th'
import '@formatjs/intl-pluralrules/locale-data/id'

import '@formatjs/intl-numberformat/polyfill-force'
import '@formatjs/intl-numberformat/locale-data/en'
import '@formatjs/intl-numberformat/locale-data/my'
import '@formatjs/intl-numberformat/locale-data/sg'
import '@formatjs/intl-numberformat/locale-data/twq'
import '@formatjs/intl-numberformat/locale-data/th'
import '@formatjs/intl-numberformat/locale-data/id'

import '@formatjs/intl-datetimeformat/polyfill-force'
import '@formatjs/intl-datetimeformat/locale-data/en'
import '@formatjs/intl-datetimeformat/locale-data/my'
import '@formatjs/intl-datetimeformat/locale-data/sg'
import '@formatjs/intl-datetimeformat/locale-data/twq'
import '@formatjs/intl-datetimeformat/locale-data/th'
import '@formatjs/intl-datetimeformat/locale-data/id'

import '@formatjs/intl-relativetimeformat/polyfill-force'
import '@formatjs/intl-relativetimeformat/locale-data/en'
import '@formatjs/intl-relativetimeformat/locale-data/my'
import '@formatjs/intl-relativetimeformat/locale-data/sg'
import '@formatjs/intl-relativetimeformat/locale-data/twq'
import '@formatjs/intl-relativetimeformat/locale-data/th'
import '@formatjs/intl-relativetimeformat/locale-data/id'


import localeData from 'Locales/messages/data';

import 'Sass/style.scss';

// addLocaleData([
//   ...en,
//   ...zh,
//   ...ko,
//   ...ja,
//   ...vi,
//   ...fil,
//   ...sg,
//   ...kr,
//   ...my,
//   ...id,
//   ...th,
//   ...twq,
//   ...az,
//   ...arabia,
//   ...ru
// ]);

export const language = process.env.REACT_APP_LOCALE || 'en';
const local_language = language == 'hk' || language=='arabia_en' ? 'en' : language=='arabia' ? 'ar':language;
if(language==='arabia_en'|| language==='arabia'){
  document.body.classList.add(`lang-${local_language}`);
  document.documentElement.lang =
  local_language === 'zh' ? 'zh-Hans' : local_language === 'ja' ? 'ja' : local_language==='ar'?'ar':'en';
}
else{
document.body.classList.add(`lang-${language}`);
  if (language === 'th') {
    document.documentElement.lang = 'th';
  }
  else {
    document.documentElement.lang =
    language === 'zh' ? 'zh-Hans' : language === 'ja' ? 'ja' : 'en';
  }
}
// Define user's language. Different browsers have the user locale defined
// on different fields on the `navigator` object, so we make sure to account

const messages = language=='arabia_en' || language==='arabia'? localeData[local_language] : localeData[language];
// If browser doesn't support Intl (i.e. Safari), then we manually import
// the intl polyfill and locale data.

const renderApp = () => {
  ReactDOM.render(
    <IntlProvider locale={local_language} messages={messages}>
      <ContextContainer>
        <Routing />
      </ContextContainer>
    </IntlProvider>,
    document.getElementById('root')
  );
};
// if (!window.Intl) {
//   // eslint-disable-next-line no-restricted-properties
//   require.ensure(
//     [
//       'intl',
//       'intl/locale-data/jsonp/en.js',
//       'intl/locale-data/jsonp/zh.js',
//       'intl/locale-data/jsonp/ko.js',
//       'intl/locale-data/jsonp/ja.js',
//       'intl/locale-data/jsonp/vi.js',
//       'intl/locale-data/jsonp/my.js',
//       'intl/locale-data/jsonp/in.js',
//       'intl/locale-data/jsonp/th.js',
//       'intl/locale-data/jsonp/twq.js',
//       'intl/locale-data/jsonp/az.js',
//       'intl/locale-data/jsonp/sg.js',
//       'intl/locale-data/jsonp/ar.js',
//       'intl/locale-data/jsonp/ru.js',
//       'intl/locale-data/jsonp/fil.js'
//     ],
//     (require) => {
//       require('intl');
//       require('intl/locale-data/jsonp/en.js');
//       require('intl/locale-data/jsonp/zh.js');
//       require('intl/locale-data/jsonp/ko.js');
//       require('intl/locale-data/jsonp/vi.js');
//       require('intl/locale-data/jsonp/ja.js');
//       require('intl/locale-data/jsonp/kr.js');
//       require('intl/locale-data/jsonp/my.js');
//       require('intl/locale-data/jsonp/in.js');
//       require('intl/locale-data/jsonp/th.js');
//       require('intl/locale-data/jsonp/twq.js');
//       require('intl/locale-data/jsonp/az.js');
//       require('intl/locale-data/jsonp/sg.js');
//       require('intl/locale-data/jsonp/ar.js');
//       require('intl/locale-data/jsonp/ru.js');
//       require('intl/locale-data/jsonp/fil.js');
//       ReactDOM.render(
//         <IntlProvider locale={local_language} messages={messages}>
//           <ContextContainer>
//             <Routing />
//           </ContextContainer>
//         </IntlProvider>,
//         document.getElementById('root')
//       );
//     }
//   );
// } else {
//   ReactDOM.render(
//     <IntlProvider locale={local_language} messages={messages}>
//       <ContextContainer>
//         <Routing />
//       </ContextContainer>
//     </IntlProvider>,
//     document.getElementById('root')
//   );
// }

renderApp();

PageView();
